export class AutoSuggest {
    autoSuggestDisplayValue: any;
    autoSuggestValueCol1: string;
    autoSuggestValueCol2: string;
    autoSuggestValueCol3: string;
    searchObject : any;

    constructor(autoSuggestDisplayValue, autoSuggestValueCol1?, autoSuggestValueCol2?, autoSuggestValueCol3?  , object?) {
        this.autoSuggestDisplayValue = autoSuggestDisplayValue;
        this.autoSuggestValueCol1 = !!autoSuggestValueCol1 ? autoSuggestValueCol1 : '';
        this.autoSuggestValueCol2 = !!autoSuggestValueCol2 ? autoSuggestValueCol2 : '';
        this.autoSuggestValueCol3 = !!autoSuggestValueCol3 ? autoSuggestValueCol3 : '';
        this.searchObject = object;

    }

    get displayName() : string {
       return !!this.autoSuggestValueCol1 ? this.autoSuggestValueCol1 : (!!this.autoSuggestValueCol2 ? this.autoSuggestValueCol2 : (!!this.autoSuggestValueCol3 ? this.autoSuggestValueCol3 : null))
    }

}